import axios from "axios"
import { getBackendBaseUrl, getUserToken, getAdminApiUrl } from "@/utils/common"

const baseUrl : string = getBackendBaseUrl()

export function useCoupon() {
    const getHeaders = () => {
        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getUserToken()}`,
        }
    }

    const getPromotions = async () => {
        try {
            const adminUrl = getAdminApiUrl()
            const response = await axios.get(baseUrl + 'api/coupons/promotions', {headers: getHeaders()})
            
            const processedData = response.data.data.map((promo: any) => {
                // If backend sent a local link by mistake, or it's a relative path, force production
                let img = promo.image_url || promo.image || ''
                
                if (img.includes('127.0.0.1') || !img.startsWith('http')) {
                    const filename = img.split('/').pop()
                    promo.image_url = `${adminUrl}static/uploads/coupons/${filename}`
                } else {
                    promo.image_url = img
                }
                return promo
            })

            return {
                status: response.data.success ? 'success' : 'error',
                data: processedData
            }
        } catch (error: any) {
            return {
                status: 'error',
                message: error.response?.data?.message || 'Failed to fetch promotions.'
            }
        }
    }

    const validateCoupon = async (code: string, email: string, totalAmount: number) => {
        try {
            const response = await axios.post(baseUrl + 'api/coupons/validate', {
                code,
                email,
                total_amount: totalAmount
            }, {headers: getHeaders()})
            
            return {
                status: 'success',
                data: response.data.data
            }
        } catch (error: any) {
            return {
                status: 'error',
                message: error.response?.data?.message || 'Invalid coupon or an error occurred.'
            }
        }
    }

    const applyCoupon = async (code: string, bookingNumber: string) => {
        try {
            const response = await axios.post(baseUrl + 'api/coupons/apply', {
                code,
                booking_number: bookingNumber
            }, {headers: getHeaders()})
            
            return {
                status: 'success',
                data: response.data
            }
        } catch (error: any) {
            return {
                status: 'error',
                message: error.response?.data?.message || 'Failed to apply coupon.'
            }
        }
    }

    return { getPromotions, validateCoupon, applyCoupon }
}
